import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const CompanyLogo = memo<ISvgProps>((props, { className }) => (
  <Svg
    className={className}
    width="185.387"
    height="34.446"
    viewBox="0 0 185.387 34.446"
    role="img"
    aria-labelledby="companyLogoTitle"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#64d7a4" />
        <stop offset="1" stopColor="#3477eb" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#e33559" />
        <stop offset="1" stopColor="#ee8636" />
      </linearGradient>
    </defs>
    <g id="Group_14120" data-name="Group 14120" transform="translate(-209 -2621.35)">
      <g
        id="PerksBar"
        transform="translate(265.612 2625.448)"
        style={{
          mixBlendMode: 'normal',
          isolation: 'isolate',
        }}
      >
        <g
          id="Group_14093"
          data-name="Group 14093"
          transform="translate(0 0)"
          style={{
            mixBlendMode: 'normal',
            isolation: 'isolate',
          }}
        >
          <path
            id="Path_21192"
            data-name="Path 21192"
            d="M236.1,744.86q5.152,0,7.909,1.811t2.759,5.932q0,4.154-2.792,6T236,760.444h-1.628v7.71h-5.183v-22.7a29.425,29.425,0,0,1,3.588-.465Q234.675,744.861,236.1,744.86Zm.332,4.42q-.565,0-1.113.033t-.947.066v6.646H236a8.829,8.829,0,0,0,4.055-.731,2.81,2.81,0,0,0,1.362-2.726,3.271,3.271,0,0,0-.349-1.594,2.658,2.658,0,0,0-1-1.014,4.491,4.491,0,0,0-1.579-.532A13.122,13.122,0,0,0,236.436,749.28Z"
            transform="translate(-229.193 -742.368)"
            fill="#0a1e55"
          />
          <path
            id="Path_21193"
            data-name="Path 21193"
            d="M252.922,761.443a10.691,10.691,0,0,1,.715-4.071,8.733,8.733,0,0,1,1.877-2.908,7.826,7.826,0,0,1,2.675-1.76,8.371,8.371,0,0,1,3.107-.6,7.721,7.721,0,0,1,5.882,2.276q2.16,2.277,2.16,6.7,0,.432-.033.947c-.022.343-.045.648-.066.913H258.006a3.289,3.289,0,0,0,1.43,2.426,5.74,5.74,0,0,0,3.389.9,14.255,14.255,0,0,0,2.675-.25,10.063,10.063,0,0,0,2.143-.614l.665,4.02a6.7,6.7,0,0,1-1.063.4,13.816,13.816,0,0,1-1.478.349q-.814.151-1.744.25a17.494,17.494,0,0,1-1.862.1,11,11,0,0,1-4.1-.7,7.985,7.985,0,0,1-2.892-1.91,7.584,7.584,0,0,1-1.694-2.875A11.365,11.365,0,0,1,252.922,761.443Zm11.63-1.894a5.116,5.116,0,0,0-.216-1.229,3.086,3.086,0,0,0-.564-1.063,3.023,3.023,0,0,0-.964-.764,3.143,3.143,0,0,0-1.446-.3,3.334,3.334,0,0,0-1.429.282,2.964,2.964,0,0,0-1,.748,3.353,3.353,0,0,0-.614,1.08,7.1,7.1,0,0,0-.316,1.246Z"
            transform="translate(-234.461 -744.263)"
            fill="#0a1e55"
          />
          <path
            id="Path_21194"
            data-name="Path 21194"
            d="M287.861,756.991q-.665-.165-1.562-.348a9.649,9.649,0,0,0-1.927-.183,9.055,9.055,0,0,0-1.114.083,6.514,6.514,0,0,0-.98.183v13.358h-4.951V753.536a29.845,29.845,0,0,1,3.14-.881,18.091,18.091,0,0,1,4.037-.415c.267,0,.587.016.964.049s.753.078,1.13.133.753.123,1.131.2a5.358,5.358,0,0,1,.963.283Z"
            transform="translate(-241.145 -744.298)"
            fill="#0a1e55"
          />
          <path
            id="Path_21195"
            data-name="Path 21195"
            d="M299.268,756.069q.731-.793,1.511-1.651t1.51-1.7q.731-.843,1.377-1.6t1.113-1.321h5.888q-1.762,2.022-3.44,3.863t-3.671,3.8a23.032,23.032,0,0,1,2.06,2.147q1.062,1.248,2.06,2.579t1.827,2.663q.83,1.332,1.4,2.43h-5.693q-.531-.866-1.211-1.916t-1.442-2.1q-.763-1.048-1.608-2.014a13.562,13.562,0,0,0-1.675-1.633v7.661h-4.951V742.283l4.951-.8Z"
            transform="translate(-245.58 -741.485)"
            fill="#0a1e55"
          />
          <path
            id="Path_21196"
            data-name="Path 21196"
            d="M324.025,766.493a4.948,4.948,0,0,0,1.927-.265,1.027,1.027,0,0,0,.565-1.03,1.263,1.263,0,0,0-.731-1.046,13.816,13.816,0,0,0-2.226-1.014,22.737,22.737,0,0,1-2.11-.9,6.214,6.214,0,0,1-1.611-1.113,4.5,4.5,0,0,1-1.03-1.546,5.707,5.707,0,0,1-.366-2.16,4.672,4.672,0,0,1,1.828-3.888,7.954,7.954,0,0,1,5.017-1.429,16.148,16.148,0,0,1,3.058.282,14.334,14.334,0,0,1,2.326.615l-.864,3.855a18.223,18.223,0,0,0-1.877-.532,10.211,10.211,0,0,0-2.277-.233q-2.326,0-2.326,1.3a1.339,1.339,0,0,0,.1.532,1.135,1.135,0,0,0,.4.449,5.575,5.575,0,0,0,.815.467q.514.251,1.312.552a20.311,20.311,0,0,1,2.692,1.19,6.454,6.454,0,0,1,1.678,1.266,3.918,3.918,0,0,1,.864,1.509,6.72,6.72,0,0,1,.249,1.922,4.431,4.431,0,0,1-1.944,3.913,9.7,9.7,0,0,1-5.5,1.326,15.814,15.814,0,0,1-3.872-.4,15.605,15.605,0,0,1-2.143-.665l.831-4.021a16.245,16.245,0,0,0,2.592.781A12.592,12.592,0,0,0,324.025,766.493Z"
            transform="translate(-252.256 -744.263)"
            fill="#0a1e55"
          />
          <path
            id="Path_21197"
            data-name="Path 21197"
            d="M346.323,768.453q-1.894,0-3.772-.117a26.637,26.637,0,0,1-3.9-.548v-22.33a33.343,33.343,0,0,1,3.489-.449q1.894-.15,3.522-.149a23.974,23.974,0,0,1,4.037.316,9.567,9.567,0,0,1,3.174,1.079,5.662,5.662,0,0,1,2.076,2.01,5.879,5.879,0,0,1,.748,3.074,4.878,4.878,0,0,1-2.659,4.353,5.442,5.442,0,0,1,2.991,2.259,6.5,6.5,0,0,1,.8,3.224,6.191,6.191,0,0,1-2.641,5.45Q351.54,768.453,346.323,768.453ZM343.7,754.164h2.525a7.037,7.037,0,0,0,3.423-.615,2.13,2.13,0,0,0,1.03-1.977,2.032,2.032,0,0,0-1.063-1.961,6.837,6.837,0,0,0-3.124-.565q-.665,0-1.429.016t-1.362.083Zm0,3.954v5.948c.377.044.786.078,1.229.1s.93.032,1.461.032a8.97,8.97,0,0,0,3.755-.664,2.465,2.465,0,0,0,1.43-2.459,2.409,2.409,0,0,0-1.2-2.277,7.017,7.017,0,0,0-3.423-.681Z"
            transform="translate(-256.681 -742.368)"
            fill="#0a1e55"
          />
          <path
            id="Path_21198"
            data-name="Path 21198"
            d="M371.3,752.1a11.465,11.465,0,0,1,3.655.5,5.691,5.691,0,0,1,2.343,1.428,5.262,5.262,0,0,1,1.246,2.26,11.112,11.112,0,0,1,.366,2.957v10.3q-1.064.233-2.957.548a28.421,28.421,0,0,1-4.586.316,14.54,14.54,0,0,1-3.074-.3,6.664,6.664,0,0,1-2.376-.98,4.476,4.476,0,0,1-1.529-1.778,6.126,6.126,0,0,1-.532-2.692,5.093,5.093,0,0,1,.614-2.592,4.736,4.736,0,0,1,1.645-1.695,7.456,7.456,0,0,1,2.36-.913,13.219,13.219,0,0,1,2.757-.283,15.84,15.84,0,0,1,1.711.083,7.691,7.691,0,0,1,1.213.216v-.466a2.743,2.743,0,0,0-.764-2.026,3.705,3.705,0,0,0-2.659-.764,17.022,17.022,0,0,0-2.492.182,10.734,10.734,0,0,0-2.127.515l-.631-3.988q.432-.133,1.08-.283t1.412-.266q.764-.116,1.612-.2T371.3,752.1Zm.4,14.488q.731,0,1.4-.033a9.68,9.68,0,0,0,1.063-.1v-3.755c-.2-.044-.5-.089-.9-.133a9.77,9.77,0,0,0-2.409.016,3.443,3.443,0,0,0-1.08.316,1.855,1.855,0,0,0-.732.631,1.759,1.759,0,0,0-.266,1,1.7,1.7,0,0,0,.781,1.612A4.322,4.322,0,0,0,371.7,766.593Z"
            transform="translate(-262.696 -744.263)"
            fill="#0a1e55"
          />
          <path
            id="Path_21199"
            data-name="Path 21199"
            d="M396.855,756.991q-.665-.165-1.562-.348a9.646,9.646,0,0,0-1.927-.183,9.054,9.054,0,0,0-1.113.083,6.545,6.545,0,0,0-.981.183v13.358h-4.951V753.536a29.86,29.86,0,0,1,3.141-.881,18.094,18.094,0,0,1,4.038-.415q.4,0,.963.049c.377.033.753.078,1.13.133s.753.123,1.13.2a5.366,5.366,0,0,1,.964.283Z"
            transform="translate(-268.91 -744.298)"
            fill="#0a1e55"
          />
        </g>
      </g>
      <g id="Group_14108" data-name="Group 14108" transform="translate(209 2621.85)">
        <g id="Line_89" data-name="Line 89" transform="translate(20.29 7.387)">
          <path
            id="Path_21145"
            data-name="Path 21145"
            d="M290.994,519.7l-.3.291a.2.2,0,0,1,.029-.031c.007-.008.014-.015.022-.024.027-.029.056-.059.085-.087l0,0C290.886,519.794,290.939,519.747,290.994,519.7Z"
            transform="translate(-290.693 -513.431)"
            fill="#5d5d5d"
          />
          <path
            id="Path_21146"
            data-name="Path 21146"
            d="M316.275,474.955h0l-1.794,1.735-1.919,1.855,0,0h0l1.919-1.855,1.794-1.734,0,0Z"
            transform="translate(-309.491 -474.949)"
            fill="#5d5d5d"
          />
        </g>
        <path
          id="Path_21147"
          data-name="Path 21147"
          d="M230.262,474.952l-3.717,3.59h0l1.919-1.855,1.8-1.737Z"
          transform="translate(-215.238 -467.562)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21148"
          data-name="Path 21148"
          d="M295.31,649.619c-.052.055-.1.1-.157.151Z"
          transform="translate(-274.238 -617.766)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21149"
          data-name="Path 21149"
          d="M302.186,608.969l-3.716,3.591-.1.1-2.074,2,2.175-2.1Z"
          transform="translate(-275.219 -582.81)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21150"
          data-name="Path 21150"
          d="M339.085,608.259h0Z"
          transform="translate(-312.015 -582.199)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21151"
          data-name="Path 21151"
          d="M344.826,480.518l.073.07-.1-.09-.014-.013L339.1,474.99h0l3.454,3.338Z"
          transform="translate(-312.032 -467.596)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21152"
          data-name="Path 21152"
          d="M380.59,515.063c.063.063.126.13.185.2-.055-.062-.112-.12-.169-.179l-.092-.092Z"
          transform="translate(-347.642 -501.993)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21153"
          data-name="Path 21153"
          d="M380.983,566.67q.088-.088.172-.181c-.054.062-.112.122-.171.181Z"
          transform="translate(-348.046 -546.28)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21154"
          data-name="Path 21154"
          d="M382.213,565.337c.055-.06.109-.123.163-.188-.039.051-.083.1-.126.149C382.238,565.31,382.226,565.324,382.213,565.337Z"
          transform="translate(-349.104 -545.128)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21155"
          data-name="Path 21155"
          d="M382.4,516.942a4.456,4.456,0,0,1,.3.37q-.147-.2-.311-.382A.107.107,0,0,1,382.4,516.942Z"
          transform="translate(-349.25 -503.662)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21156"
          data-name="Path 21156"
          d="M385.5,556.9a5.227,5.227,0,0,0,.478-.881A4.894,4.894,0,0,1,385.5,556.9Z"
          transform="translate(-351.933 -537.276)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21157"
          data-name="Path 21157"
          d="M386.007,521.731c-.073-.134-.15-.266-.234-.392C385.857,521.465,385.935,521.6,386.007,521.731Z"
          transform="translate(-352.165 -507.454)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21158"
          data-name="Path 21158"
          d="M390.163,550.349q.057-.183.1-.37Q390.222,550.166,390.163,550.349Z"
          transform="translate(-355.94 -532.082)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21159"
          data-name="Path 21159"
          d="M390.453,531.589c.035.122.064.245.09.37C390.516,531.834,390.487,531.711,390.453,531.589Z"
          transform="translate(-356.189 -516.268)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21160"
          data-name="Path 21160"
          d="M391.329,536.412c.008-.123.013-.249.013-.374a5.262,5.262,0,0,0-.079-.909,5.1,5.1,0,0,1,.08.909C391.343,536.163,391.339,536.289,391.329,536.412Z"
          transform="translate(-356.886 -519.312)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21161"
          data-name="Path 21161"
          d="M294.7,565.384h0l-2.212-2.136-.578-.56.58.559Z"
          transform="translate(-271.452 -543.012)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21162"
          data-name="Path 21162"
          d="M316.271,474.95v0h0l-1.794,1.734-1.919,1.855h0l1.919-1.855,1.794-1.734,0,0Z"
          transform="translate(-289.201 -467.562)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21163"
          data-name="Path 21163"
          d="M311.823,612.559l3.717-3.59-3.716,3.591Z"
          transform="translate(-288.573 -582.81)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21164"
          data-name="Path 21164"
          d="M339.083,608.259h0Z"
          transform="translate(-312.015 -582.199)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21165"
          data-name="Path 21165"
          d="M361.763,610.063l1.133-1.094-1.132,1.1Z"
          transform="translate(-331.518 -582.81)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21166"
          data-name="Path 21166"
          d="M414.143,562.529l.094-.09-.035.035-.578.56Z"
          transform="translate(-376.114 -542.797)"
          fill="#5d5d5d"
        />
        <path
          id="Union_2"
          data-name="Union 2"
          d="M13.408,31.877l-.024-.024h0l-2.175-2.1,3.716-3.592.1-.1,0,0,2.2,2.13,0,0,.971-.938h0l1.132-1.1L23.15,22.47l.1-.1,2.211-2.136.579-.56.034-.035.048-.045a4.05,4.05,0,0,0,1.189-2.872,4,4,0,0,0-.046-.614c-.01-.065-.021-.132-.035-.2s-.028-.132-.045-.2-.033-.128-.053-.191a1.412,1.412,0,0,0-.047-.139,3.79,3.79,0,0,0-.279-.628c-.026-.048-.053-.1-.082-.142a4.115,4.115,0,0,0-.266-.384c-.022-.031-.048-.064-.073-.093-.077-.092-.157-.182-.241-.267l-.022-.021-.661-.639h0l-2.206-2.132L21.226,9.12,17.232,5.262,15.127,7.3l-.1.1-.006-.006,0,0L13.225,9.124l-1.919,1.854,0,0-.1.1L8.994,13.215h0l-.524.507c-.028.026-.056.051-.083.077l0,0-.061.061-.024.026-.022.024a.223.223,0,0,0-.03.03l-.018.018L8.2,14c-.011.013-.024.026-.033.039-.03.031-.056.063-.084.095s-.044.053-.065.082a.689.689,0,0,0-.048.06c-.018.024-.036.048-.053.073s-.045.061-.064.091l-.062.093c-.01.015-.019.03-.028.046-.022.033-.041.067-.061.1a.929.929,0,0,0-.053.093.5.5,0,0,0-.03.056c-.017.031-.034.063-.049.095s-.037.076-.054.115c-.006.013-.013.026-.018.04-.015.036-.031.071-.046.108s-.035.085-.05.13a.251.251,0,0,0-.014.037c-.017.045-.033.093-.048.141l-.017.053c-.012.039-.024.08-.033.121-.007.022-.013.045-.018.067-.012.049-.025.1-.035.152,0,.013-.006.026-.008.039-.011.052-.02.1-.028.158,0,.013,0,.025-.007.038-.01.065-.017.13-.024.2-.014.136-.021.273-.021.413A4.054,4.054,0,0,0,8.333,19.6l.082.08.579.56,2.212,2.136L7.387,26.061,1.619,20.488l-.1-.1c-.03-.03-.059-.059-.087-.09s-.057-.061-.085-.091L1.31,20.17l-.049-.056c-.027-.031-.055-.063-.08-.1-.053-.063-.105-.128-.154-.195s-.1-.132-.142-.2a.088.088,0,0,1-.006-.009c-.046-.068-.089-.136-.132-.205s-.085-.144-.124-.217-.072-.133-.1-.2C.5,18.961.49,18.93.477,18.9s-.037-.078-.054-.119-.045-.1-.065-.155c-.031-.078-.06-.158-.087-.238-.014-.04-.026-.079-.039-.118-.05-.167-.095-.336-.13-.509-.007-.039-.016-.077-.022-.117-.015-.084-.028-.169-.039-.256C.036,17.343.03,17.3.026,17.259s-.009-.09-.011-.136-.007-.087-.009-.132C0,16.9,0,16.815,0,16.725s0-.177.006-.265c0-.044,0-.087.009-.132s.007-.087.011-.129.008-.085.014-.13v0c.006-.043.012-.084.018-.126l.022-.128c.006-.042.015-.084.023-.126.018-.084.037-.167.057-.25.007-.029.016-.06.024-.089.017-.063.035-.124.055-.187.01-.03.019-.063.03-.093s.031-.09.046-.135c.038-.1.077-.2.12-.291a.13.13,0,0,1,.011-.026c.026-.06.054-.121.084-.179.01-.022.02-.043.031-.062.024-.047.047-.093.073-.139.035-.065.073-.13.111-.193.019-.032.039-.065.061-.1s.053-.084.081-.124.065-.1.1-.142a5.029,5.029,0,0,1,.323-.4l.042-.046c.045-.053.093-.1.141-.151l.152-.145L7.387,7.39h0l.1-.1L11.2,3.7h0l.1-.1.887-.857L13.277,1.7a.081.081,0,0,1,.011-.013l.046-.048.219-.212a.258.258,0,0,1,.024-.022,5.439,5.439,0,0,1,7.47.165l.028.029a.094.094,0,0,1,.02.019l5.978,5.776,5.687,5.494.014.013.03.029.107.1.054.055c.057.059.113.117.168.18l.032.036a.3.3,0,0,1,.031.035c.033.038.065.077.1.117a4.872,4.872,0,0,1,.321.441c.038.053.072.109.105.166h0c.037.061.073.122.106.186.02.036.039.073.057.109s.033.065.049.1.045.091.064.139a.416.416,0,0,1,.03.066c.028.06.053.121.077.185a5.126,5.126,0,0,1,.226.734c.008.038.017.076.024.112s.017.084.023.126.014.085.022.127.012.085.018.127.01.086.014.13.009.087.011.13.007.087.009.131c0,.088.007.176.007.265s0,.178-.007.266c0,.045,0,.089-.009.133s-.007.089-.011.134-.01.084-.015.126c-.011.087-.024.172-.039.257-.007.037-.014.076-.022.112,0,.018-.007.037-.011.055a5.218,5.218,0,0,1-.2.7c-.014.04-.03.079-.045.118s-.035.09-.054.133c-.027.065-.057.128-.086.191a.267.267,0,0,1-.015.032c-.035.073-.071.144-.111.215a4.542,4.542,0,0,1-.241.4c-.014.022-.028.045-.043.066-.039.056-.078.111-.119.165s-.1.129-.15.19-.12.143-.185.212c-.049.054-.1.109-.154.163l-.179.172L21.074,31.853h0l-.126.122a5.436,5.436,0,0,1-7.539-.1ZM1.49,20.363c-.021-.022-.042-.043-.061-.066.028.03.057.06.087.09l.1.1,5.767,5.573-.1.1Z"
          transform="translate(12.046 0)"
          stroke="rgba(0,0,0,0)"
          strokeWidth="1"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_21169"
          data-name="Path 21169"
          d="M295.132,500.6l0,0-.1.1h0l-2.21,2.135-.45.434s0,0,0,0c-.025.022-.052.045-.077.069l.524-.507h0l2.212-2.136Z"
          transform="translate(-271.779 -489.619)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21170"
          data-name="Path 21170"
          d="M355.784,616.759l0,0-.971.938,0,0Z"
          transform="translate(-325.542 -589.509)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21171"
          data-name="Path 21171"
          d="M413.623,516.549l.661.639-.142-.135Z"
          transform="translate(-376.114 -503.335)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21172"
          data-name="Path 21172"
          d="M180.289,438.935c0,.125,0,.251-.013.374s-.022.247-.039.367c-.014.1-.031.192-.049.287-.01.048-.02.094-.031.141h0q-.044.187-.1.37c-.05.162-.109.321-.175.476a5.23,5.23,0,0,1-.478.881h0c-.094.137-.193.269-.3.4-.053.064-.108.127-.162.188s-.113.122-.172.181l-.179.172-5.688,5.5h0l-.1.1-3.717,3.59-2.175,2.1h0l-.157.151-.029.028a5.435,5.435,0,0,1-7.477-.157l-.024-.022h0l-5.995-5.792-5.767-5.573-.1-.1a4.871,4.871,0,0,1-.333-.368c-.053-.063-.105-.129-.154-.195-.074-.1-.146-.2-.213-.307-.022-.035-.045-.07-.066-.106-.043-.071-.085-.144-.125-.217s-.073-.136-.105-.2a.356.356,0,0,1-.025-.052c-.031-.064-.06-.13-.088-.2-.017-.039-.032-.078-.048-.118a5.18,5.18,0,0,1-.359-1.9c0-.125,0-.248.013-.371,0-.041.006-.081.01-.122s.011-.108.018-.161a0,0,0,0,1,0,0c.006-.042.011-.084.018-.126l.021-.127c.015-.085.032-.168.05-.251s.041-.165.063-.247.048-.162.074-.242.055-.158.085-.237q.029-.076.063-.151c.021-.049.042-.1.064-.144a.659.659,0,0,1,.034-.071c.031-.064.063-.127.1-.19a.021.021,0,0,1,.006-.013c.039-.071.08-.143.122-.213s.07-.115.108-.171a5.119,5.119,0,0,1,.462-.605l.017-.018c.055-.062.111-.12.168-.179l.15-.144,5.743-5.549.1-.1,3.716-3.59.1-.1,1.038-1,.933-.9a.089.089,0,0,1,.011-.013l.024-.025.248-.24.018-.017a5.434,5.434,0,0,1,7.468.167l.028.027a.129.129,0,0,1,.02.02l2.157,2.084-3.715,3.589-.1.1h0l-2.2-2.128-2.105,2.034-.1.1-.006-.006-1.8,1.737-1.919,1.855h0l-2.313,2.235h0l-.538.52c-.024.02-.046.042-.069.064s-.039.038-.057.057-.013.01-.014.015c-.024.021-.045.043-.066.066l-.024.025a.571.571,0,0,0-.038.043c-.045.048-.087.1-.126.146s-.077.094-.112.143a.19.19,0,0,0-.021.029q-.044.057-.084.118a.339.339,0,0,0-.032.05c-.031.042-.057.085-.084.13a.035.035,0,0,0-.006.01c-.032.053-.063.106-.092.162a.008.008,0,0,0,0,.007c-.021.038-.041.076-.059.115s-.038.076-.055.115a.2.2,0,0,0-.018.039l-.046.108a1.323,1.323,0,0,0-.05.13.116.116,0,0,0-.014.036q-.034.088-.059.176a1.821,1.821,0,0,0-.05.176.066.066,0,0,0-.006.024c-.017.062-.032.125-.043.188a4,4,0,0,0-.083.814,4.1,4.1,0,0,0,.028.475q.008.078.021.155c.006.038.013.077.02.115.014.077.031.151.049.227.008.036.018.074.029.111s.028.1.043.147.036.111.056.165h0a4.051,4.051,0,0,0,.244.538,3.85,3.85,0,0,0,.2.333c.073.108.15.213.232.312.042.05.084.1.127.147s.087.1.134.142l.021.02.644.622,4.237,4.094,3.992,3.857,0,0,.971-.937,1.133-1.1.1-.1,3.818-3.688h0l2.209-2.135.578-.56.083-.08,0,0a3.829,3.829,0,0,0,.258-.286,4.119,4.119,0,0,0,.339-.478c.032-.052.063-.105.092-.158.059-.108.114-.219.163-.331.024-.056.048-.113.07-.172.029-.077.056-.155.081-.235a.005.005,0,0,1,0,0,4.075,4.075,0,0,0,.134-.588c.015-.1.028-.2.035-.305s.013-.207.013-.312a4.025,4.025,0,0,0-.181-1.2c-.039-.126-.084-.251-.134-.371-.024-.06-.051-.119-.08-.178s-.056-.118-.088-.175l-.059-.106c-.041-.07-.083-.139-.127-.206s-.09-.133-.139-.2c-.071-.1-.148-.191-.23-.28-.042-.048-.085-.1-.132-.14l-.019-.021-.661-.639-2.207-2.132.1-.1,1.919-1.854L172.9,429.6l5.687,5.495.014.013.1.09,0,0,.092.092c.058.059.115.118.169.179q.164.183.311.382.086.116.164.235c.084.126.161.258.234.392.038.069.073.14.108.211l.013.029c.029.06.057.122.083.184s.041.1.062.149c.028.073.054.146.08.22a.064.064,0,0,0,0,.015c.013.038.025.076.036.113s.024.08.036.122c.034.122.063.245.09.37.008.042.015.084.024.126A5.261,5.261,0,0,1,180.289,438.935Z"
          transform="translate(-145.833 -422.209)"
          fill="url(#linear-gradient-2)"
        />
        <path
          id="Path_21173"
          data-name="Path 21173"
          d="M209.049,500.6l-.1.1-2.212,2.136-.45.434s0,0,0,0c-.031.027-.06.053-.09.081l.538-.52h0l2.313-2.236Z"
          transform="translate(-197.738 -489.619)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21174"
          data-name="Path 21174"
          d="M269.778,616.763l-.971.937,0,0,.971-.937Z"
          transform="translate(-251.579 -589.509)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21175"
          data-name="Path 21175"
          d="M311.833,581.929h0Z"
          transform="translate(-288.582 -559.557)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21176"
          data-name="Path 21176"
          d="M332.334,560.348c.092-.092.179-.189.262-.289a3.836,3.836,0,0,1-.258.286Z"
          transform="translate(-306.211 -540.751)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21177"
          data-name="Path 21177"
          d="M333.423,522.259c.081.09.158.184.23.28C333.58,522.442,333.5,522.349,333.423,522.259Z"
          transform="translate(-307.147 -508.245)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21178"
          data-name="Path 21178"
          d="M337.283,553.49c.057-.108.112-.217.162-.331C337.4,553.271,337.342,553.382,337.283,553.49Z"
          transform="translate(-310.467 -534.817)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21179"
          data-name="Path 21179"
          d="M314.706,481.432l.02.021-.162-.155-.521-.5-2.206-2.13,0,0,.1-.1h0l1.919-1.855,1.794-1.734h0l0,0-1.794,1.735-1.919,1.855-.1.1,2.207,2.132Z"
          transform="translate(-288.582 -467.579)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21180"
          data-name="Path 21180"
          d="M340.493,544.154c.015-.1.027-.2.035-.305C340.521,543.951,340.508,544.054,340.493,544.154Z"
          transform="translate(-313.227 -526.811)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21181"
          data-name="Path 21181"
          d="M339.724,534.267c0,.105,0,.209-.013.312.007-.1.011-.207.011-.312a4.069,4.069,0,0,0-.179-1.2A4.023,4.023,0,0,1,339.724,534.267Z"
          transform="translate(-312.41 -517.541)"
          fill="#5d5d5d"
        />
        <path
          id="Path_21233"
          data-name="Path 21233"
          d="M14.006,27.581l-3.843,3.712.933.9Z"
          transform="translate(13.133 -20.241)"
          fill="rgba(0,0,0,0.3)"
        />
        <path
          id="Path_21234"
          data-name="Path 21234"
          d="M9.838,31.274,13.762,27.5l-.9-.864Z"
          transform="translate(9.526 -5.168)"
          fill="rgba(0,0,0,0.3)"
        />
      </g>
    </g>
  </Svg>
));

CompanyLogo.displayName = 'CompanyLogo';

export default CompanyLogo;
